// extracted by mini-css-extract-plugin
export default {"section":"Create_section__wTWP7"};